<template>
  <div class="mb-4 create-study">
    <app-button
      variant="cta"
      class="button--secondary mb-4"
      @click.native="showForm = !showForm"
      ref="toggle"
    >
      {{ toggleText }}
    </app-button>

    <card title="Create a new study" v-if="showForm">
      <alert
        v-if="isShowingError"
        :show="isShowingError"
        type="error"
        :description="error"
      ></alert>
      <form @submit.prevent autocomplete="off">
        <text-field
          name="study-title"
          label="We are currently studying:"
          placeholder="Chicken ears"
          type="single"
          v-model="title"
          class="mb-4"
        />

        <app-button
          :disabled="title === ''"
          @click.native="submitHandler"
          variant="cta"
        >
          Add study
        </app-button>
      </form>
    </card>
  </div>
</template>

<script>
import TextField from '@/components/form/TextField';
import Card from '@/components/global/Card.vue';
import { mapActions } from 'vuex';

export default {
  name: 'create-study',
  components: { TextField, Card },
  data() {
    return {
      showForm: false,
      title: '',
      isShowingError: false,
      error: null,
    };
  },
  methods: {
    ...mapActions('studies', ['postStudy']),
    async submitHandler() {
      const response = await this.postStudy({ title: this.title });

      if (response && response.data && response.data.statusCode > 400) {
        this.isShowingError = true;
        this.error = response.data.message;
      } else {
        this.$router.push({
          name: 'admin-study',
          params: { id: response.id },
        });
      }
    },
  },
  computed: {
    toggleText() {
      return this.showForm ? 'Cancel' : 'Add new study';
    },
  },
};
</script>

<style lang="scss" scoped></style>
